<!--
  DESKTOP
  -->
<div class="global__desktop" *ngIf="!globalVars.isMobile()">
  <left-bar></left-bar>

  <div class="global__content__flex">
    <div class="global__content__width d-flex vh-100">
      <messages-inbox
        class="messages-inbox__desktop-column"
        (selectedThreadEmitter)="selectedThread = $event"
        [messageThreads]="
          globalVars.messageResponse
            ? globalVars.messageResponse.OrderedContactsWithMessages
            : null
        "
      ></messages-inbox>
      <messages-thread-view
        class="messages-thread__desktop-column"
        [messageThread]="
          globalVars.messageResponse
            ? selectedThread
              ? selectedThread
              : globalVars.messageResponse.OrderedContactsWithMessages[0]
            : null
        "
      ></messages-thread-view>
    </div>
  </div>
</div>

<!--
  MOBILE
  -->
<div class="global__mobile flex-column" *ngIf="globalVars.isMobile()">
  <left-bar-mobile></left-bar-mobile>

  <div class="d-flex flex-column flex-grow-1 vh-100">
    <!-- Inbox Header -->
    <div
      *ngIf="!showThreadView"
      class="global__top-bar__height d-flex align-items-center fs-18px font-weight-bold pl-15px border-bottom border-color-grey"
    >
      <top-bar-mobile-navigation-control
        class="mr-15px d-lg-none d-inline-block"
      ></top-bar-mobile-navigation-control>

      <div class="d-flex justify-content-end align-items-right pr-10px">
        <div
          *ngIf="
            this.globalVars.messageResponse != null &&
              this.globalVars.messageResponse.NumberOfUnreadThreads > 0;
            then thenEnvelopeBlock;
            else elseEnvelopeBlock
          "
        ></div>
        <ng-template #thenEnvelopeBlock>
          <i
            (click)="_markAllMessagesReadMobile()"
            class="fc-blue far fa-envelope cursor-pointer messages-header-icon-row__icon pt-2px"
          ></i>
        </ng-template>
        <ng-template #elseEnvelopeBlock>
          <i class="far fa-envelope cursor-auto fs-20px pt-2px"></i>
        </ng-template>
      </div>

      Messages

      <!-- Settings -->
      <div class="d-flex w-100 justify-content-end align-items-right pr-10px">
        <i
          (click)="_toggleSettingsTray()"
          class="fas fa-sliders-h cursor-pointer messages-header-icon-row__icon pt-2px"
        ></i>
      </div>
    </div>

    <!-- Thread View Header -->
    <div
      *ngIf="showThreadView"
      class="global__top-bar__height d-flex align-items-center fs-18px font-weight-bold pl-15px border-bottom border-color-grey"
    >
      <div class="cursor-pointer color-grey7 mr-15px">
        <a
          class="link--unstyled"
          style="text-align: center"
          (click)="navigateToInbox()"
          queryParamsHandling="merge"
        >
          <i class="fa fa-angle-left"></i>
        </a>
      </div>

      <div
        class="messages-thread__avatar mr-15px"
        [avatar]="selectedThread.PublicKeyBase58Check"
        [ngClass]="{ 'cursor-auto': !selectedThread.ProfileEntryResponse }"
        [routerLink]="
          selectedThread.ProfileEntryResponse
            ? AppRoutingModule.profilePath(selectedThreadDisplayName)
            : []
        "
        queryParamsHandling="merge"
      ></div>
      <a
        class="link--unstyled"
        [routerLink]="
          selectedThread.ProfileEntryResponse
            ? AppRoutingModule.profilePath(selectedThreadDisplayName)
            : []
        "
        queryParamsHandling="merge"
      >
        {{ selectedThreadDisplayName }}
      </a>
      <span
        *ngIf="selectedThread.ProfileEntryResponse?.IsVerified"
        class="ml-1 text-primary"
      >
        <i class="fas fa-check-circle fa-md align-middle"></i>
      </span>
    </div>

    <!-- Scrollable Content -->
    <div class="global__mobile-scrollable-section">
      <messages-inbox
        *ngIf="!showThreadView"
        class="global__mobile-scrollable-section"
        (selectedThreadEmitter)="_handleMessageThreadSelectedMobile($event)"
        [isMobile]="true"
        [messageThreads]="
          globalVars.messageResponse
            ? globalVars.messageResponse.OrderedContactsWithMessages
            : null
        "
      ></messages-inbox>
      <messages-thread-view
        *ngIf="showThreadView"
        class="messages-thread__desktop-column"
        [isMobile]="true"
        [messageThread]="
          globalVars.messageResponse
            ? selectedThread
              ? selectedThread
              : globalVars.messageResponse.OrderedContactsWithMessages[0]
            : null
        "
      ></messages-thread-view>
    </div>
  </div>
  <bottom-bar-mobile
    *ngIf="!showThreadView"
    class="global__bottom-bar-mobile"
  ></bottom-bar-mobile>
</div>
